import ProgressSection from "./ProgressSection";
import ThinkingSection from "./ThinkingSection";
import ResearchSection from "./ResearchSection";
import TransferSection from "./TransferSection";
import SummarizationSection from "./SummarizationSection";
import { Tag } from "../types";
import React from "react";
import { getAgentFromProgress, getAgentFromTransfer } from "./utils";

interface TimelineSectionsProps {
  actualTags: Tag[];
  progressEndState: any;
}

const TimelineSections: React.FC<TimelineSectionsProps> = ({ actualTags, progressEndState }) => {
  const elements = [];

  let i = 0;

  while (i < actualTags.length) {
    const tag = actualTags[i];

    if (tag.type === "progress") {
      const progressGroup = [];

      let j = i;

      while (j < actualTags.length && actualTags[j].type === "progress") {
        progressGroup.push(actualTags[j]);
        j++;
      }

      elements.push(
        <ProgressSection
          tags={progressGroup}
          stableKey={`progress-group-${i}`}
          progressEndState={progressEndState}
        />
      );

      i = j;
    }

    else if (tag.type === "thinking") {
      elements.push(
        <ThinkingSection
          tag={tag}
          stableKey={`thinking-${i}`}
        />
      );
      i++;
    }

    else if (tag.type === "research") {
      elements.push(
        <ResearchSection
          tag={tag}
          stableKey={`research-${i}`}
        />
      );
      i++;
    }

    else if (tag.type === "transfer") {
      const agent = getAgentFromTransfer(tag.content);
      const progressGroup: Tag[] = [];

      let j = i + 1;
      while (j < actualTags.length && actualTags[j].type === 'progress') {
        const pAgent = getAgentFromProgress(actualTags[j].content);
        if (pAgent && agent && pAgent === agent) {
          progressGroup.push(actualTags[j]);
          j++;
        } else {
          break;
        }
      }
      elements.push(
        <div key={`transfer-group-${i}`}>
          <TransferSection
            tag={tag}
            stableKey={`transfer-${i}`}
          />
          {progressGroup.length > 0 && (
            <ProgressSection
              tags={progressGroup}
              stableKey={`progress-under-transfer-${i}`}
              progressEndState={progressEndState}
              hideHeader
            />
          )}
        </div>
      );

      i = progressGroup.length > 0 ? j : i + 1;
    }

    else if (tag.type === "summarization") {
      elements.push(
        <SummarizationSection
          tag={tag}
          stableKey={`summarization-${i}`}
        />
      );
      i++;
    }

    else {
      i++;
    }
  }

  return <>{elements}</>;
};

export default TimelineSections;